import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, Radio, Wifi } from 'lucide-react';

const SignalProtectionPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="container mx-auto px-4 py-20">
        {/* Back Button */}
        <Link
          to="/self-phone"
          className="inline-flex items-center text-indigo-400 hover:text-indigo-300 transition-colors mb-12"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to SELF Phone
        </Link>

        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 via-purple-400 to-blue-400">
            Advanced Signal Protection System
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Military-grade encryption and signal protection for your Harmony Agent communications, ensuring complete privacy and security.
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16">
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20"
          >
            <Shield className="w-12 h-12 text-indigo-400 mb-4" />
            <h3 className="text-xl font-semibold mb-4">Quantum Encryption</h3>
            <p className="text-gray-300">
              State-of-the-art quantum-resistant encryption protocols protecting all data transmissions.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20"
          >
            <Lock className="w-12 h-12 text-indigo-400 mb-4" />
            <h3 className="text-xl font-semibold mb-4">Zero-Knowledge Protocol</h3>
            <p className="text-gray-300">
              Complete privacy with zero-knowledge proof systems ensuring no data exposure during transmission.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20"
          >
            <Radio className="w-12 h-12 text-indigo-400 mb-4" />
            <h3 className="text-xl font-semibold mb-4">Signal Masking</h3>
            <p className="text-gray-300">
              Advanced signal masking technology that conceals communication patterns and metadata.
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20"
          >
            <Wifi className="w-12 h-12 text-indigo-400 mb-4" />
            <h3 className="text-xl font-semibold mb-4">Multi-Path Routing</h3>
            <p className="text-gray-300">
              Dynamic routing through multiple secure channels to prevent signal interception and ensure delivery.
            </p>
          </motion.div>
        </div>

        {/* Additional Info */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-indigo-950/30 p-8 rounded-2xl backdrop-blur-sm border border-indigo-500/20">
            <h3 className="text-2xl font-semibold mb-6 text-center">Protection Features</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <ul className="space-y-4 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  End-to-End Encryption
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Secure Key Exchange
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Anti-Tampering Measures
                </li>
              </ul>
              <ul className="space-y-4 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Signal Anonymization
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Intrusion Detection
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-indigo-400 rounded-full mr-3"></span>
                  Secure Hardware Integration
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignalProtectionPage; 